module.exports = __webpack_public_path__ + "static/media/ac_logo.e98638c2.svg";